import {
  createProductGroupingPayload,
  productGroupingListResponse,
  updateProductGroupingPayload,
} from 'interfaces/ProductGrouping';
import api from 'services';

const path = '/productGrouping';

// Listar agrupamentos
export const getProductGroupingList = async (): Promise<productGroupingListResponse> => {
  const response = await api.get<productGroupingListResponse>(`${path}/list`);
  return response.data;
};

// Buscar agrupamento por ID
export const getProductGroupingById = async (id: number): Promise<productGroupingListResponse> => {
  const response = await api.get<productGroupingListResponse>(`${path}/${id}`);
  return response.data;
};

// Criar agrupamento
export const createProductGrouping = async (
  payload: createProductGroupingPayload,
): Promise<productGroupingListResponse> => {
  const response = await api.post<productGroupingListResponse>(`${path}/`, payload);
  return response.data;
};

// Atualizar agrupamento
export const updateProductGrouping = async (
  payload: updateProductGroupingPayload,
): Promise<productGroupingListResponse> => {
  const { id, ...data } = payload;
  const response = await api.put<productGroupingListResponse>(`${path}/${id}`, data);
  return response.data;
};

// Deletar agrupamento
export const deleteProductGrouping = async (id: number): Promise<void> => {
  await api.delete(`${path}/${id}`);
};
